<template>
  <div class="flex flex-col pr-24 md:grid md:grid-cols-12 md:gap-24 md:pr-0">
    <div class="mb-24 md:col-span-7 md:mb-0">
      <ProductDescription
        class="mb-18"
        :listing
        :publication-state
        @refresh-listings="$emit('refresh-listings')"
      />

      <BackboxInfo :listing />
    </div>

    <QuickActions
      class="md:col-span-5"
      :has-backpricer-enabled
      :listing
      :reference-market
    />
  </div>
</template>

<script setup lang="ts">
import type { MarketCountryCode } from '@backmarket/http-api'
import type { Listing } from '@backmarket/http-api/src/api-specs-seller-backoffice/merchants/listings.types'

import BackboxInfo from './components/BackboxInfo.vue'
import ProductDescription from './components/ProductDescription.vue'
import QuickActions from './components/QuickActions.vue'

defineEmits(['refresh-listings'])
defineProps<{
  listing: Listing
  publicationState: string
  referenceMarket: MarketCountryCode | ''
  hasBackpricerEnabled: boolean
}>()
</script>
